(function () {
  "use strict";

  var VERSION = "20260713-fetch-welcome-r9-format-experiment";
  if (window.__tk9FetchWelcomeGameVersion === VERSION) return;
  window.__tk9FetchWelcomeGameVersion = VERSION;

  var config = Object.assign({
    enabled: false,
    autoArm: true,
    popupId: "0b9fdc9b-4979-41eb-b47d-63adc389256e",
    logoUrl: "",
    dogUrl: "",
    happyDogUrl: "",
    triggerDelayMs: 6000,
    triggerScrollRatio: 0.25,
    openDelayMs: 0,
    handoffTimeoutMs: 3000,
    sdkRetryLimit: 8,
    telemetryEndpoint: "https://teamk9-welcome-telemetry.teamk9-guard.workers.dev/welcome-telemetry",
    storageKey: "tk9_fetch_welcome_game_r1",
    contextStorageKey: "tk9_fetch_welcome_context_v1",
    forceParam: "tk9_fetch_game",
    excludeCustomer: false,
    offerCode: "WELCOME"
  }, window.TeamK9FetchWelcomeGameConfig || {});

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (error) { params = { get: function () { return ""; } }; }
  var forceValue = String(params.get(config.forceParam) || "").toLowerCase();
  var experimentForceValue = String(params.get("tk9_welcome_experiment") || "").toLowerCase();
  var experimentForceMode = experimentForceValue === "force" || experimentForceValue === "1" || experimentForceValue === "on";
  var experimentForceVariant = String(params.get("tk9_welcome_variant") || "").toLowerCase();
  var forceMode = forceValue === "force" || forceValue === "1" || forceValue === "on" || (experimentForceMode && experimentForceVariant === "fetch");
  var suppressForForcedMystery = experimentForceMode && experimentForceVariant === "mystery";
  var offMode = forceValue === "0" || forceValue === "off";

  function isCartPath() {
    var path = String(window.location.pathname || "/").replace(/\/+$/, "") || "/";
    return path === "/cart" || /^\/[a-z]{2}(?:-[a-z]{2})?\/cart$/i.test(path);
  }

  function alreadyCompleted() {
    try {
      return window.localStorage.getItem(config.storageKey) === "completed" ||
        Boolean(window.localStorage.getItem("tk9_welcome_code_unlocked"));
    } catch (error) {
      return false;
    }
  }

  function alreadyDismissed() {
    try { return window.sessionStorage.getItem(config.storageKey) === "dismissed"; }
    catch (error) { return false; }
  }

  function knownSubscriber() {
    try {
      return Boolean(window.postscript && typeof window.postscript.getSubscriberId === "function" && window.postscript.getSubscriberId());
    } catch (error) {
      return false;
    }
  }

  function commerceOverlayOpen() {
    return document.documentElement.classList.contains("tk9-slide-cart-lock") ||
      Boolean(document.body && document.body.classList.contains("tk9-slide-cart-lock")) ||
      Boolean(document.querySelector("[data-tk9-slide-cart].is-open,[data-tk9-slide-cart][aria-hidden='false']"));
  }

  if (offMode || isCartPath()) return;
  if (!forceMode && (!config.enabled || config.excludeCustomer || alreadyCompleted() || alreadyDismissed())) return;
  if (!config.dogUrl || !config.happyDogUrl || !config.logoUrl || !config.popupId) return;

  [config.logoUrl, config.dogUrl, config.happyDogUrl].forEach(function (url) {
    var preload = new Image();
    preload.decoding = "async";
    preload.src = url;
  });

  var productPathRules = [
    { match: /custom-patch|patches-bundle|hook-loop-patch|patch-for-harness/i, path: "custom_patches", family: "patches_message" },
    { match: /tactical-leash|bungee-dog-leash|dog-leash/i, path: "tactical_leash", family: "harness_walk" },
    { match: /tactical-pouch|dog-pouch/i, path: "tactical_pouch", family: "harness_walk" },
    { match: /dog-collar|tactical-collar/i, path: "dog_collar", family: "harness_walk" },
    { match: /all-metal-tactical-harness|metal-buckle-harness|dog-harness/i, path: "metal_buckle_harness", family: "harness_walk" },
    { match: /dual-headrest-cooling-fans|cooling-fan|headrest-fan/i, path: "backseat_cooling_fans", family: "car_travel" },
    { match: /hard-bottom-csce|single-seat-cover|seat-cover|backseat-dog-bed|cargo-cover/i, path: "hard_bottom_seat_cover", family: "car_travel" },
    { match: /pet-car-safety-belt|car-safety-belt|seat-belt/i, path: "car_safety_belt", family: "car_travel" },
    { match: /travel-bowl|water-bowl/i, path: "travel_bowl", family: "car_travel" },
    { match: /dog-goggles|doggles|goggle|eye-protection/i, path: "doggles", family: "doggles_eye_protection" },
    { match: /waterproof-dog-pool-cover|dog-pool-cover|pool-cover/i, path: "dog_pool_cover", family: "pool_backyard" },
    { match: /dog-pool|foldable-pool|pet-pool/i, path: "dog_pool", family: "pool_backyard" },
    { match: /first-aid/i, path: "first_aid_kit", family: "safety_first_aid" }
  ];

  function productHandle() {
    var match = String(window.location.pathname || "").match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : "";
  }

  function productRoute() {
    var value = String(window.location.pathname || "") + " " + productHandle();
    for (var index = 0; index < productPathRules.length; index += 1) {
      if (productPathRules[index].match.test(value)) return productPathRules[index];
    }
    return { path: "unclassified_product_path", family: "unclassified_product_path" };
  }

  function productFamily() {
    return productRoute().family;
  }

  function pageType() {
    var path = String(window.location.pathname || "/");
    if (path === "/") return "home";
    if (/\/products\//i.test(path)) return "product";
    if (/\/collections\//i.test(path)) return "collection";
    if (/\/blogs\//i.test(path)) return "article";
    if (/\/pages\//i.test(path)) return "page";
    return "other";
  }

  function deviceType() {
    return window.matchMedia && window.matchMedia("(max-width: 759px)").matches ? "mobile" : "desktop";
  }

  function safeParam(name) {
    try { return String(params.get(name) || "").slice(0, 160); }
    catch (error) { return ""; }
  }

  function referrerHost() {
    try { return document.referrer ? new URL(document.referrer).hostname : ""; }
    catch (error) { return ""; }
  }

  function readContext() {
    if (state && state.context) return state.context;
    try { return JSON.parse(window.sessionStorage.getItem(config.contextStorageKey) || "null") || {}; }
    catch (error) { return {}; }
  }

  function saveContext(context) {
    if (state) state.context = context;
    try { window.sessionStorage.setItem(config.contextStorageKey, JSON.stringify(context)); }
    catch (error) {}
    return context;
  }

  function buildContext(trigger) {
    var route = productRoute();
    return saveContext({
      tk9_session_id: state.id,
      tk9_entry_path: String(window.location.pathname || "/"),
      tk9_signup_path: String(window.location.pathname || "/"),
      tk9_page_type: pageType(),
      tk9_product_handle: productHandle(),
      tk9_product_path_interest: route.path,
      tk9_product_family: route.family,
      tk9_hero_family_interest: route.family,
      tk9_product_path_confidence: route.path === "unclassified_product_path" ? "unclassified" : "observed_high",
      tk9_product_path_basis: route.path === "unclassified_product_path" ? "signup_page_unclassified" : "signup_page_observed",
      tk9_device: deviceType(),
      tk9_trigger: trigger || "unknown",
      tk9_popup_id: config.popupId,
      tk9_popup_variant: "welcome_fetch_r5",
      tk9_offer_code: config.offerCode,
      tk9_referrer_host: referrerHost(),
      tk9_utm_source: safeParam("utm_source"),
      tk9_utm_medium: safeParam("utm_medium"),
      tk9_utm_campaign: safeParam("utm_campaign"),
      tk9_utm_content: safeParam("utm_content"),
      tk9_context_at: new Date().toISOString()
    });
  }

  function track(name, detail) {
    var context = readContext();
    var payload = Object.assign({}, context, {
      event: name,
      tk9_experiment: "welcome_fetch_r5",
      tk9_product_handle: productHandle(),
      tk9_product_path_interest: productRoute().path,
      tk9_product_family: productFamily(),
      tk9_entry_path: window.location.pathname,
      tk9_device: deviceType(),
      tk9_at: new Date().toISOString()
    }, detail || {});
    sendFirstPartyTelemetry(name, payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag("event", name, Object.assign({ transport_type: "beacon" }, payload));
    } catch (error) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {}
    try { if (typeof window.fbq === "function") window.fbq("trackCustom", name, payload); }
    catch (error) {}
    try {
      var klaviyoMetricNames = {
        tk9_fetch_impression: "WELCOME Fetch Impression",
        tk9_fetch_game_started: "WELCOME Fetch Game Started",
        tk9_fetch_ball_caught: "WELCOME Fetch Ball Caught",
        tk9_fetch_postscript_requested: "WELCOME Fetch Form Requested",
        tk9_fetch_postscript_opened: "WELCOME Fetch Form Opened",
        tk9_fetch_email_submitted: "WELCOME Fetch Email Submitted",
        tk9_fetch_phone_submitted: "WELCOME Fetch Phone Submitted",
        tk9_fetch_subscriber_created: "WELCOME Fetch Subscriber Created",
        tk9_fetch_postscript_error: "WELCOME Fetch Postscript Error",
        tk9_fetch_fallback_revealed: "WELCOME Fetch Fallback Revealed"
      };
      if (klaviyoMetricNames[name]) {
        klaviyoQueue().push(["track", klaviyoMetricNames[name], {
          tk9_event: name,
          tk9_experiment: payload.tk9_experiment,
          tk9_session_id: payload.tk9_session_id,
          tk9_popup_variant: payload.tk9_popup_variant,
          tk9_trigger: payload.tk9_trigger,
          tk9_attempt: payload.tk9_attempt,
          tk9_reason: payload.tk9_reason,
          tk9_product_handle: payload.tk9_product_handle,
          tk9_product_path_interest: payload.tk9_product_path_interest,
          tk9_product_family: payload.tk9_product_family,
          tk9_device: payload.tk9_device,
          tk9_at: payload.tk9_at
        }]);
      }
    } catch (error) {}
    try {
      if (typeof window.mpx === "function") {
        var merchantingUrl = new URL(window.location.href);
        var merchantingFields = {
          tk9_event: name,
          tk9_experiment: payload.tk9_experiment,
          tk9_session_id: payload.tk9_session_id,
          tk9_popup_variant: payload.tk9_popup_variant,
          tk9_trigger: payload.tk9_trigger,
          tk9_screen: payload.tk9_screen,
          tk9_attempt: payload.tk9_attempt,
          tk9_reason: payload.tk9_reason,
          tk9_product_handle: payload.tk9_product_handle,
          tk9_product_path: payload.tk9_product_path_interest,
          tk9_product_family: payload.tk9_product_family,
          tk9_device: payload.tk9_device
        };
        Object.keys(merchantingFields).forEach(function (key) {
          var value = merchantingFields[key];
          if (value === undefined || value === null || value === "") return;
          merchantingUrl.searchParams.set(key, String(value).slice(0, 160));
        });
        window.mpx("track", name, Object.assign({}, payload, { landingUrl: merchantingUrl.toString() }));
      }
    }
    catch (error) {}
    try { window.dispatchEvent(new CustomEvent(name, { detail: payload })); } catch (error) {}
  }

  function sendFirstPartyTelemetry(name, payload) {
    if (!config.telemetryEndpoint || !/^tk9_fetch_(?:impression|game_started|ball_caught|postscript_requested|postscript_opened|email_submitted|phone_submitted|subscriber_created|postscript_error|fallback_revealed)$/.test(name)) return;
    var body;
    try {
      body = JSON.stringify({
        event: name,
        session_id: String(payload.tk9_session_id || state && state.id || "").slice(0, 80),
        reason: String(payload.tk9_reason || "").slice(0, 80),
        device: String(payload.tk9_device || deviceType()).slice(0, 20),
        product_handle: String(payload.tk9_product_handle || "").slice(0, 120),
        product_path: String(payload.tk9_product_path_interest || "").slice(0, 120),
        product_family: String(payload.tk9_product_family || "").slice(0, 120),
        popup_variant: String(payload.tk9_popup_variant || "welcome_fetch_r8").slice(0, 80),
        trigger: String(payload.tk9_trigger || "").slice(0, 40),
        attempt: Number(payload.tk9_attempt || 0),
        client_at: String(payload.tk9_at || new Date().toISOString()).slice(0, 40)
      });
    } catch (error) { return; }
    function beaconFallback() {
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(config.telemetryEndpoint, new Blob([body], { type: "application/json" }));
      } catch (error) {}
    }
    try {
      if (typeof window.fetch === "function") {
        window.fetch(config.telemetryEndpoint, {
          method: "POST",
          credentials: "omit",
          keepalive: true,
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: body
        }).catch(beaconFallback);
      } else beaconFallback();
    } catch (error) { beaconFallback(); }
  }

  function randomId() {
    try { return window.crypto.randomUUID(); }
    catch (error) { return "fetch-" + Date.now() + "-" + Math.random().toString(36).slice(2); }
  }

  var state = {
    id: randomId(),
    host: null,
    shadow: null,
    overlay: null,
    lane: null,
    ball: null,
    dog: null,
    status: null,
    attempt: null,
    retry: null,
    confetti: null,
    screen: "intro",
    attempts: 0,
    caught: false,
    mounted: false,
    shown: false,
    openingPopup: false,
    previousOverflow: "",
    previousBodyOverflow: "",
    teaserStyle: null,
    missTimer: 0,
    startTimer: 0,
    triggerTimer: 0,
    openDelayTimer: 0,
    openRetryTimer: 0,
    handoffTimer: 0,
    popupImpressionHandler: null,
    postscriptReadyHandler: null,
    fallbackOffer: null,
    claimOffer: null,
    continueShopping: null,
    claimInFlight: false,
    claimTimer: 0,
    fallbackActive: false,
    context: null,
    postscriptLifecycleHandler: null,
    emailTracked: false,
    phoneTracked: false,
    subscriberTracked: false
  };

  function cleanDogName(values) {
    var fields = values && typeof values === "object" ? Object.keys(values) : [];
    for (var index = 0; index < fields.length; index += 1) {
      if (!/dogs?\s*name|pet\s*name/i.test(fields[index])) continue;
      return String(values[fields[index]] || "").trim().slice(0, 80);
    }
    return "";
  }

  function klaviyoQueue() {
    if (window.klaviyo && typeof window.klaviyo.push === "function") return window.klaviyo;
    window.klaviyo = window.klaviyo || [];
    return window.klaviyo;
  }

  function syncKlaviyoProfile(email, dogName) {
    var normalizedEmail = String(email || "").trim().toLowerCase();
    if (!normalizedEmail || normalizedEmail.indexOf("@") < 1) return;
    var context = readContext();
    var properties = {
      email: normalizedEmail,
      tk9_entry_path: context.tk9_entry_path || "",
      tk9_signup_path: context.tk9_signup_path || context.tk9_entry_path || "",
      tk9_product_handle: context.tk9_product_handle || "",
      tk9_product_path_interest: context.tk9_product_path_interest || "unclassified_product_path",
      tk9_product_family: context.tk9_product_family || "unclassified_product_path",
      tk9_hero_family_interest: context.tk9_hero_family_interest || "unclassified_product_path",
      tk9_product_path_confidence: context.tk9_product_path_confidence || "unclassified",
      tk9_product_path_basis: context.tk9_product_path_basis || "signup_page_unclassified",
      tk9_popup_id: config.popupId,
      tk9_popup_variant: context.tk9_popup_variant || "welcome_fetch_r5",
      tk9_welcome_source: "welcome_fetch_game",
      tk9_welcome_offer_code: config.offerCode,
      tk9_welcome_game_session_id: context.tk9_session_id || state.id,
      tk9_welcome_trigger: context.tk9_trigger || "unknown",
      tk9_welcome_device: context.tk9_device || deviceType(),
      tk9_welcome_attempts: Number(context.tk9_attempts || state.attempts || 0),
      tk9_welcome_caught_at: context.tk9_caught_at || "",
      tk9_utm_source: context.tk9_utm_source || "",
      tk9_utm_medium: context.tk9_utm_medium || "",
      tk9_utm_campaign: context.tk9_utm_campaign || "",
      tk9_utm_content: context.tk9_utm_content || ""
    };
    if (dogName) properties.DogsName = dogName;
    var eventProperties = Object.assign({}, properties);
    delete eventProperties.email;
    try {
      var queue = klaviyoQueue();
      queue.push(["identify", properties]);
      queue.push(["track", "WELCOME Fetch Form Submitted", eventProperties]);
    } catch (error) {
      track("tk9_fetch_klaviyo_sync_error", { tk9_reason: "queue_exception", tk9_session_id: state.id });
    }
  }

  function installPostscriptLifecycleTracking() {
    if (state.postscriptLifecycleHandler) return;
    state.postscriptLifecycleHandler = function (event) {
      var detail = event && event.detail || {};
      if (String(detail.popupId || "") !== String(config.popupId)) return;
      var values = detail.values && typeof detail.values === "object" ? detail.values : {};
      if (detail.type === "formSubmit") {
        var dogName = cleanDogName(values);
        if (values.email && !state.emailTracked) {
          state.emailTracked = true;
          syncKlaviyoProfile(values.email, dogName);
          track("tk9_fetch_email_submitted", {
            tk9_has_dog_name: Boolean(dogName),
            tk9_session_id: readContext().tk9_session_id || state.id
          });
        }
        if (values.phone && !state.phoneTracked) {
          state.phoneTracked = true;
          track("tk9_fetch_phone_submitted", { tk9_session_id: readContext().tk9_session_id || state.id });
        }
      } else if (detail.type === "subscriberCreated" && !state.subscriberTracked) {
        state.subscriberTracked = true;
        track("tk9_fetch_subscriber_created", {
          tk9_discount_code_present: Boolean(detail.discountCode),
          tk9_auto_apply_enabled: Boolean(detail.autoApplyOfferEnabled),
          tk9_session_id: readContext().tk9_session_id || state.id
        });
      } else if (detail.type === "close") {
        track("tk9_fetch_postscript_closed", {
          tk9_hard_close: Boolean(detail.hard),
          tk9_session_id: readContext().tk9_session_id || state.id
        });
      }
    };
    window.addEventListener("postscriptPopup", state.postscriptLifecycleHandler);
  }

  var css = [
    ":host{all:initial;position:fixed;inset:0;z-index:2147483000;font-family:Arial,Helvetica,sans-serif;color:#151515}",
    "*{box-sizing:border-box}",
    "[hidden]{display:none!important}",
    "button{font:inherit;touch-action:manipulation}",
    ".backdrop{position:fixed;inset:0;display:grid;place-items:stretch;background:#f4f4f2;overscroll-behavior:contain}",
    ".panel{position:relative;width:100%;height:100dvh;min-height:100dvh;overflow:hidden;background:#f4f4f2}",
    ".screen{position:absolute;inset:0;display:grid;grid-template-rows:auto 1fr auto;padding:max(18px,env(safe-area-inset-top)) 20px max(12px,env(safe-area-inset-bottom));overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;opacity:0;pointer-events:none;transform:translateY(8px);transition:opacity .18s ease,transform .18s ease}",
    ".screen.active{opacity:1;pointer-events:auto;transform:none}",
    ".top{display:grid;grid-template-columns:42px 1fr 42px;align-items:center;min-height:42px;position:relative;z-index:4}",
    ".logo{display:block;width:82px;max-height:56px;margin:auto;object-fit:contain}",
    ".icon{display:grid;width:42px;height:42px;place-items:center;border:0;border-radius:50%;background:transparent;color:#151515;cursor:pointer;font-size:27px;line-height:1}",
    ".icon:hover{background:#e4e4df}.icon:focus-visible,.primary:focus-visible,.ball:focus-visible{outline:3px solid #142c50;outline-offset:3px}",
    ".content{display:grid;align-content:start;padding-top:clamp(55px,10dvh,96px);text-align:center;position:relative;z-index:3}",
    ".eyebrow{margin:0 0 10px;color:#087d69;font-size:12px;font-weight:800;text-transform:uppercase}",
    "h1,h2{max-width:470px;margin:0 auto;font-family:Impact,'Arial Black',Arial,sans-serif;font-weight:900;letter-spacing:0;line-height:.92;text-transform:uppercase}",
    ".hook,.value{display:block;white-space:nowrap}.hook{font-size:clamp(38px,10.8vw,55px)}.value{margin-top:3px;color:#087d69;font-size:clamp(40px,11.2vw,58px)}",
    ".lede{max-width:400px;margin:14px auto 0;color:#31322f;font-size:17px;font-weight:700;line-height:1.28;text-wrap:balance}",
    ".primary{display:inline-grid;width:min(100%,390px);min-height:56px;margin:20px auto 0;padding:0 18px;place-items:center;border:0;border-radius:5px;background:#17d4af;color:#071a16;cursor:pointer;font-family:Impact,'Arial Black',Arial,sans-serif;font-size:21px;text-transform:uppercase}",
    ".intro-dog{position:absolute;left:50%;bottom:-14px;width:min(94%,470px);height:auto;transform:translateX(-50%);pointer-events:none;user-select:none}",
    ".footer{min-height:26px;margin:0;color:#666761;text-align:center;font-size:11px;line-height:1.3;position:relative;z-index:3}",
    ".game-wrap{display:grid;align-content:center;gap:14px;min-height:100%;position:relative;z-index:3}",
    ".score{display:flex;justify-content:center;gap:8px;color:#666761;font-size:12px;font-weight:800;text-transform:uppercase}",
    ".lane{position:relative;width:min(100%,460px);height:clamp(260px,42dvh,390px);margin:auto;overflow:hidden;border:1px solid #c5c6c0;border-radius:6px;background:linear-gradient(180deg,#e7eef0 0 55%,#ccdba8 55% 71%,#8aa66e 71%);box-shadow:inset 0 0 0 7px rgba(255,255,255,.5)}",
    ".lane:before{content:'CATCH THE BALL';position:absolute;left:50%;top:18px;transform:translateX(-50%);color:rgba(20,44,80,.54);font-size:12px;font-weight:900;white-space:nowrap}",
    ".lane:after{content:'';position:absolute;left:0;right:0;bottom:25%;height:5px;background:rgba(255,255,255,.82)}",
    ".ball{position:absolute;z-index:5;left:-90px;top:42%;display:grid;width:74px;height:74px;place-items:center;border:0;border-radius:50%;background:radial-gradient(circle at -14% 50%,transparent 0 57%,rgba(255,255,255,.92) 58% 62%,transparent 63%),radial-gradient(circle at 114% 50%,transparent 0 57%,rgba(255,255,255,.92) 58% 62%,transparent 63%),radial-gradient(circle at 35% 28%,#fbff9d 0 5%,#edf45f 28%,#d7e446 62%,#9ea923 100%);box-shadow:0 10px 20px rgba(17,17,17,.2),inset -5px -7px 10px rgba(80,90,10,.25);cursor:pointer;opacity:0;color:transparent}",
    ".lane.running .ball{opacity:1;animation:tk9FetchFlight var(--flight,2800ms) cubic-bezier(.18,.66,.5,1) forwards}.lane.caught .ball{animation-play-state:paused;transform:scale(1.16) rotate(12deg);box-shadow:0 0 0 10px rgba(23,212,175,.3),0 12px 26px rgba(17,17,17,.24)}",
    ".dog{position:absolute;z-index:2;left:50%;bottom:-5px;width:min(92%,410px);height:auto;transform:translateX(-50%);pointer-events:none;user-select:none}.dog.happy{bottom:4px;width:min(86%,380px)}",
    ".status{min-height:22px;margin:0;color:#142c50;text-align:center;font-size:15px;font-weight:900;text-transform:uppercase}",
    ".fallback-offer{display:grid;width:min(100%,390px);margin:0 auto;gap:10px;text-align:center}.fallback-offer[hidden]{display:none!important}.offer-code{margin:0;padding:12px 16px;border:2px dashed #142c50;border-radius:5px;background:#fff;color:#142c50;font-family:Impact,'Arial Black',Arial,sans-serif;font-size:32px;letter-spacing:1px}.offer-note{margin:0;color:#444641;font-size:13px;font-weight:700;line-height:1.3}.secondary{display:inline-grid;width:min(100%,390px);min-height:46px;margin:0 auto;padding:0 18px;place-items:center;border:1px solid #142c50;border-radius:5px;background:transparent;color:#142c50;cursor:pointer;font-size:14px;font-weight:900;text-transform:uppercase}",
    ".confetti{position:absolute;z-index:6;inset:0;overflow:hidden;pointer-events:none}.piece{position:absolute;left:50%;top:46%;width:8px;height:14px;border-radius:1px;background:var(--c);opacity:0;animation:tk9FetchConfetti .88s cubic-bezier(.18,.78,.3,1) var(--delay) forwards}",
    "@keyframes tk9FetchFlight{0%{left:-90px;top:58%;transform:rotate(0)}42%{top:var(--apex,18%)}100%{left:calc(100% + 18px);top:55%;transform:rotate(520deg)}}",
    "@keyframes tk9FetchConfetti{0%{opacity:0;transform:translate(-50%,-50%) scale(.65)}9%{opacity:1}54%{opacity:1;transform:translate(calc(-50% + var(--x)),calc(-50% - var(--up))) rotate(var(--spin))}100%{opacity:0;transform:translate(calc(-50% + var(--xe)),calc(-50% + var(--down))) rotate(var(--spine))}}",
    "@media(max-width:759px){.screen{min-height:100dvh}.content{padding-top:clamp(58px,11dvh,96px)}}",
    "@media(max-height:700px){.game-wrap{align-content:start;padding-top:8px}.lane{height:220px}.dog{width:min(78%,330px)}.dog.happy{width:min(74%,310px)}.fallback-offer{gap:7px}.offer-code{padding:8px 14px;font-size:28px}.primary{min-height:50px;margin-top:12px}.footer{padding-top:6px}}",
    "@media(max-width:350px){.hook{font-size:35px}.value{font-size:37px}.lede{font-size:15.5px}.primary{font-size:19px}}",
    "@media(prefers-reduced-motion:reduce){.screen{transition:none}.lane.running .ball{animation-duration:5200ms}.piece{display:none}}"
  ].join("");

  function markup() {
    return '<style>' + css + '</style>' +
      '<div class="backdrop" role="dialog" aria-modal="true" aria-label="Catch your Team K9 welcome offer">' +
        '<main class="panel">' +
          '<section class="screen active" data-screen="intro">' +
            '<header class="top"><span></span><img class="logo" src="' + config.logoUrl + '" alt="Team K9"><button class="icon" type="button" data-close aria-label="Close">&times;</button></header>' +
            '<div class="content"><p class="eyebrow">Your Team K9 welcome offer</p><h1><span class="hook">Catch your deal</span><span class="value">Up to 47% off</span></h1><p class="lede">Catch the ball to unlock WELCOME. Eligible kits and bundles can bring your total up to 47% off.</p><button class="primary" type="button" data-start>Throw the deal</button></div>' +
            '<p class="footer"></p><img class="intro-dog" src="' + config.dogUrl + '" alt="" aria-hidden="true">' +
          '</section>' +
          '<section class="screen" data-screen="game">' +
            '<header class="top"><button class="icon" type="button" data-back aria-label="Back">&#8249;</button><img class="logo" src="' + config.logoUrl + '" alt="Team K9"><button class="icon" type="button" data-close aria-label="Close">&times;</button></header>' +
            '<div class="game-wrap"><div class="score"><span>Catch 1 ball</span><span aria-hidden="true">/</span><span data-attempt>Attempt 1</span></div><div class="lane" data-lane><button class="ball" type="button" data-ball aria-label="Catch the tennis ball">Ball</button><img class="dog" data-dog src="' + config.dogUrl + '" alt="" aria-hidden="true"><div class="confetti" data-confetti aria-hidden="true"></div></div><p class="status" data-status>Get ready...</p><button class="primary" type="button" data-retry hidden>Throw again</button><div class="fallback-offer" data-fallback-offer hidden><p class="offer-code" data-offer-code>' + config.offerCode + '</p><p class="offer-note">10% off, plus eligible kit and bundle savings.</p><button class="primary" type="button" data-claim-offer>Copy &amp; apply</button><button class="secondary" type="button" data-continue-shopping>Continue shopping</button></div></div>' +
            '<p class="footer">Tap the tennis ball before it crosses the screen.</p>' +
          '</section>' +
        '</main>' +
      '</div>';
  }

  function setTeaserHidden(hidden) {
    var teaser = document.getElementById("tk9-dog-offer-teaser2");
    if (!teaser) return;
    if (hidden) {
      if (!state.teaserStyle) state.teaserStyle = { visibility: teaser.style.visibility, pointerEvents: teaser.style.pointerEvents };
      teaser.style.setProperty("visibility", "hidden", "important");
      teaser.style.setProperty("pointer-events", "none", "important");
    } else if (state.teaserStyle) {
      teaser.style.visibility = state.teaserStyle.visibility || "";
      teaser.style.pointerEvents = state.teaserStyle.pointerEvents || "";
      state.teaserStyle = null;
    }
  }

  function routeTeaserToPilot() {
    try {
      window.sessionStorage.setItem("tk9_dog_offer_teaser_active_popup", config.popupId);
    } catch (error) {}
  }

  function showScreen(name) {
    state.screen = name;
    var screens = state.shadow.querySelectorAll("[data-screen]");
    for (var index = 0; index < screens.length; index += 1) {
      screens[index].classList.toggle("active", screens[index].getAttribute("data-screen") === name);
    }
    track("tk9_fetch_screen_viewed", { tk9_screen: name, tk9_session_id: state.id });
  }

  function lockPage() {
    document.documentElement.style.overflow = "hidden";
    if (document.body) document.body.style.overflow = "hidden";
  }

  function restorePage() {
    document.documentElement.style.overflow = state.previousOverflow;
    if (document.body) document.body.style.overflow = state.previousBodyOverflow;
    setTeaserHidden(false);
  }

  function removePopupImpressionListener() {
    if (!state.popupImpressionHandler) return;
    window.removeEventListener("postscriptPopup", state.popupImpressionHandler);
    state.popupImpressionHandler = null;
  }

  function removePostscriptReadyListener() {
    if (!state.postscriptReadyHandler) return;
    window.removeEventListener("postscriptReady", state.postscriptReadyHandler);
    state.postscriptReadyHandler = null;
  }

  function cancelPendingFlow() {
    window.clearTimeout(state.missTimer);
    window.clearTimeout(state.startTimer);
    window.clearTimeout(state.openDelayTimer);
    window.clearTimeout(state.openRetryTimer);
    window.clearTimeout(state.handoffTimer);
    window.clearTimeout(state.claimTimer);
    state.missTimer = 0;
    state.startTimer = 0;
    state.openDelayTimer = 0;
    state.openRetryTimer = 0;
    state.handoffTimer = 0;
    state.claimTimer = 0;
    state.openingPopup = false;
    removePopupImpressionListener();
    removePostscriptReadyListener();
  }

  function resetGameUI() {
    cancelPendingFlow();
    state.attempts = 0;
    state.caught = false;
    state.claimInFlight = false;
    state.fallbackActive = false;
    state.emailTracked = false;
    state.phoneTracked = false;
    state.subscriberTracked = false;
    if (!state.shadow) return;
    state.attempt.textContent = "Attempt 1";
    state.status.textContent = "Get ready...";
    state.retry.hidden = true;
    state.retry.style.display = "none";
    state.fallbackOffer.hidden = true;
    state.claimOffer.textContent = "Copy & apply";
    state.dog.src = config.dogUrl;
    state.dog.classList.remove("happy");
    state.lane.classList.remove("running", "caught");
    state.confetti.replaceChildren();
    showScreen("intro");
  }

  function closeGame(reason, skipPageRestore) {
    cancelPendingFlow();
    if (state.host && state.host.isConnected) state.host.remove();
    if (skipPageRestore) setTeaserHidden(false);
    else restorePage();
    state.shown = false;
    if (reason === "dismissed") {
      try { window.sessionStorage.setItem(config.storageKey, "dismissed"); } catch (error) {}
    }
    track("tk9_fetch_closed", { tk9_reason: reason || "unknown", tk9_session_id: state.id });
  }

  function createConfetti() {
    var colors = ["#17d4af", "#e8ef54", "#142c50", "#ffffff", "#ff7a59"];
    state.confetti.replaceChildren();
    for (var index = 0; index < 30; index += 1) {
      var piece = document.createElement("span");
      var x = Math.round((Math.random() - 0.5) * 300);
      var spin = 180 + Math.round(Math.random() * 540);
      piece.className = "piece";
      piece.style.setProperty("--c", colors[index % colors.length]);
      piece.style.setProperty("--delay", Math.round(Math.random() * 70) + "ms");
      piece.style.setProperty("--x", x + "px");
      piece.style.setProperty("--xe", Math.round(x * 1.18) + "px");
      piece.style.setProperty("--up", (68 + Math.round(Math.random() * 112)) + "px");
      piece.style.setProperty("--down", (90 + Math.round(Math.random() * 118)) + "px");
      piece.style.setProperty("--spin", spin + "deg");
      piece.style.setProperty("--spine", (spin + 260) + "deg");
      state.confetti.appendChild(piece);
    }
  }

  function throwBall() {
    cancelPendingFlow();
    state.attempts += 1;
    state.caught = false;
    state.attempt.textContent = "Attempt " + state.attempts;
    state.status.textContent = "Catch it";
    state.retry.hidden = true;
    state.retry.style.display = "none";
    state.fallbackOffer.hidden = true;
    state.dog.src = config.dogUrl;
    state.dog.classList.remove("happy");
    state.confetti.replaceChildren();
    state.lane.classList.remove("running", "caught");
    var flight = 2800 + Math.round(Math.random() * 700);
    var apex = 13 + Math.round(Math.random() * 18);
    state.lane.style.setProperty("--flight", flight + "ms");
    state.lane.style.setProperty("--apex", apex + "%");
    void state.lane.offsetWidth;
    state.lane.classList.add("running");
    track("tk9_fetch_ball_thrown", { tk9_attempt: state.attempts, tk9_flight_ms: flight, tk9_session_id: state.id });
    state.missTimer = window.setTimeout(function () {
      if (state.caught) return;
      state.lane.classList.remove("running");
      state.status.textContent = "Almost. Try again.";
      state.retry.hidden = false;
      state.retry.style.display = "";
      track("tk9_fetch_ball_missed", { tk9_attempt: state.attempts, tk9_session_id: state.id });
    }, flight + 100);
  }

  function rememberFallbackOffer() {
    try {
      window.localStorage.setItem(config.storageKey, "completed");
      window.localStorage.setItem("tk9_welcome_code_unlocked", config.offerCode);
      window.localStorage.setItem("tk9_welcome_discount_code", config.offerCode);
    } catch (error) {}
  }

  function applyFallbackOffer() {
    rememberFallbackOffer();
    var bridge = window.TeamK9WelcomeDiscountBridge;
    if (bridge && typeof bridge.apply === "function") {
      return Promise.resolve().then(function () { return bridge.apply(config.offerCode); }).then(function () { return true; }).catch(function () { return false; });
    }
    try { window.dispatchEvent(new CustomEvent("tk9WelcomeApplyRequest", { detail: { code: config.offerCode, source: "welcome_fetch_fallback" } })); }
    catch (error) {}
    return Promise.resolve(false);
  }

  function copyFallbackOffer() {
    var bridge = window.TeamK9WelcomeDiscountBridge;
    if (bridge && typeof bridge.copy === "function") {
      return Promise.resolve().then(function () { return bridge.copy(config.offerCode); }).then(function () { return true; }).catch(function () { return false; });
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return Promise.resolve().then(function () { return navigator.clipboard.writeText(config.offerCode); }).then(function () { return true; }).catch(function () { return false; });
    }
    return Promise.resolve(false);
  }

  function showFallbackOffer(reason) {
    window.clearTimeout(state.openRetryTimer);
    window.clearTimeout(state.handoffTimer);
    if (reason !== "impression_timeout") removePopupImpressionListener();
    removePostscriptReadyListener();
    state.openingPopup = false;
    state.fallbackActive = true;
    lockPage();
    state.status.textContent = "You caught " + config.offerCode;
    state.fallbackOffer.hidden = false;
    applyFallbackOffer();
    track("tk9_fetch_postscript_error", { tk9_reason: reason, tk9_session_id: state.id });
    track("tk9_fetch_fallback_revealed", { tk9_offer_code: config.offerCode, tk9_reason: reason, tk9_session_id: state.id });
  }

  function openPostscript(attempt) {
    if (state.openingPopup && attempt === 0) return;
    state.openingPopup = true;
    state.fallbackActive = false;
    state.status.textContent = "You caught " + config.offerCode;
    state.fallbackOffer.hidden = true;
    var popups = window.postscript && window.postscript.popups;
    if (!popups || typeof popups.open !== "function") {
      if (!state.postscriptReadyHandler) {
        state.postscriptReadyHandler = function () {
          removePostscriptReadyListener();
          window.clearTimeout(state.openRetryTimer);
          state.openingPopup = false;
          openPostscript(0);
        };
        window.addEventListener("postscriptReady", state.postscriptReadyHandler);
      }
      if (attempt < config.sdkRetryLimit) {
        state.openRetryTimer = window.setTimeout(function () { openPostscript(attempt + 1); }, 250);
      } else {
        showFallbackOffer("sdk_unavailable");
      }
      return;
    }

    removePopupImpressionListener();
    removePostscriptReadyListener();
    state.popupImpressionHandler = function (event) {
      var detail = event && event.detail || {};
      if (detail.type !== "impression" || String(detail.popupId) !== String(config.popupId)) return;
      state.openingPopup = false;
      window.clearTimeout(state.handoffTimer);
      track("tk9_fetch_postscript_opened", { tk9_popup_id: config.popupId, tk9_session_id: state.id });
      closeGame("caught", !state.fallbackActive);
    };
    window.addEventListener("postscriptPopup", state.popupImpressionHandler);

    restorePage();
    state.handoffTimer = window.setTimeout(function () {
      showFallbackOffer("impression_timeout");
    }, config.handoffTimeoutMs);
    try {
      popups.open(config.popupId, {
        activePopupBehavior: "ALWAYS_DISMISS",
        respectPopupStatus: false,
        respectCooldown: false
      });
      track("tk9_fetch_postscript_requested", { tk9_popup_id: config.popupId, tk9_session_id: state.id });
    } catch (error) {
      window.clearTimeout(state.handoffTimer);
      state.handoffTimer = 0;
      showFallbackOffer("open_exception");
    }
  }

  function catchBall(event) {
    if (event) event.preventDefault();
    if (state.caught || !state.lane.classList.contains("running")) return;
    state.caught = true;
    window.clearTimeout(state.missTimer);
    state.retry.hidden = true;
    state.retry.style.display = "none";
    state.lane.classList.add("caught");
    state.status.textContent = "You caught it";
    state.dog.src = config.happyDogUrl;
    state.dog.classList.add("happy");
    createConfetti();
    var context = Object.assign({}, readContext(), {
      tk9_attempts: state.attempts,
      tk9_caught_at: new Date().toISOString()
    });
    saveContext(context);
    track("tk9_fetch_ball_caught", { tk9_attempt: state.attempts, tk9_session_id: state.id });
    if (config.openDelayMs > 0) {
      state.openDelayTimer = window.setTimeout(function () {
        state.openDelayTimer = 0;
        openPostscript(0);
      }, config.openDelayMs);
    } else {
      openPostscript(0);
    }
  }

  function mount() {
    if (state.mounted) return;
    state.mounted = true;
    state.host = document.createElement("div");
    state.host.id = "tk9-fetch-welcome-game";
    state.host.setAttribute("data-version", VERSION);
    state.shadow = state.host.attachShadow({ mode: "open" });
    state.shadow.innerHTML = markup();
    document.body.appendChild(state.host);
    state.overlay = state.shadow.querySelector(".backdrop");
    state.lane = state.shadow.querySelector("[data-lane]");
    state.ball = state.shadow.querySelector("[data-ball]");
    state.dog = state.shadow.querySelector("[data-dog]");
    state.status = state.shadow.querySelector("[data-status]");
    state.attempt = state.shadow.querySelector("[data-attempt]");
    state.retry = state.shadow.querySelector("[data-retry]");
    state.fallbackOffer = state.shadow.querySelector("[data-fallback-offer]");
    state.claimOffer = state.shadow.querySelector("[data-claim-offer]");
    state.continueShopping = state.shadow.querySelector("[data-continue-shopping]");
    state.confetti = state.shadow.querySelector("[data-confetti]");

    var closes = state.shadow.querySelectorAll("[data-close]");
    for (var index = 0; index < closes.length; index += 1) closes[index].addEventListener("click", function () { closeGame("dismissed"); });
    state.shadow.querySelector("[data-start]").addEventListener("click", function () {
      track("tk9_fetch_game_started", { tk9_session_id: state.id });
      showScreen("game");
      window.clearTimeout(state.startTimer);
      state.startTimer = window.setTimeout(function () {
        state.startTimer = 0;
        throwBall();
      }, 620);
    });
    state.shadow.querySelector("[data-back]").addEventListener("click", function () {
      cancelPendingFlow();
      state.caught = false;
      state.lane.classList.remove("running", "caught");
      state.fallbackOffer.hidden = true;
      state.dog.src = config.dogUrl;
      state.dog.classList.remove("happy");
      state.status.textContent = "Get ready...";
      showScreen("intro");
    });
    state.retry.addEventListener("click", throwBall);
    state.claimOffer.addEventListener("click", function () {
      if (state.claimInFlight) return;
      state.claimInFlight = true;
      state.claimOffer.textContent = "Applying...";
      Promise.all([copyFallbackOffer(), applyFallbackOffer()]).then(function () {
        state.claimOffer.textContent = "WELCOME copied";
        track("tk9_fetch_fallback_claimed", { tk9_offer_code: config.offerCode, tk9_session_id: state.id });
        state.claimTimer = window.setTimeout(function () {
          state.claimTimer = 0;
          closeGame("fallback_claimed");
        }, 650);
      }).catch(function () {
        state.claimInFlight = false;
        state.claimOffer.textContent = "Copy & apply";
      });
    });
    state.continueShopping.addEventListener("click", function () {
      applyFallbackOffer();
      closeGame("fallback_continue");
    });
    state.ball.addEventListener("pointerdown", catchBall, { passive: false });
    state.ball.addEventListener("click", catchBall);
    state.shadow.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      event.preventDefault();
      closeGame("dismissed");
    });
  }

  function showGame(source) {
    if (state.shown || (!forceMode && knownSubscriber())) return;
    buildContext(source);
    if (!forceMode && commerceOverlayOpen()) {
      try { window.sessionStorage.setItem(config.storageKey, "dismissed"); } catch (error) {}
      track("tk9_fetch_suppressed", { tk9_reason: "commerce_overlay_open", tk9_trigger: source, tk9_session_id: state.id });
      return;
    }
    routeTeaserToPilot();
    mount();
    resetGameUI();
    if (!state.host.isConnected) document.body.appendChild(state.host);
    state.shown = true;
    state.previousOverflow = document.documentElement.style.overflow || "";
    state.previousBodyOverflow = document.body ? document.body.style.overflow || "" : "";
    lockPage();
    setTeaserHidden(true);
    track("tk9_fetch_impression", { tk9_trigger: source, tk9_session_id: state.id });
  }

  function scrollRatio() {
    var root = document.documentElement;
    var max = Math.max(1, root.scrollHeight - window.innerHeight);
    return Math.max(0, window.scrollY || root.scrollTop || 0) / max;
  }

  function onScroll() {
    if (scrollRatio() < config.triggerScrollRatio) return;
    window.removeEventListener("scroll", onScroll);
    window.clearTimeout(state.triggerTimer);
    showGame("scroll_25");
  }

  function arm() {
    if (knownSubscriber() && !forceMode) return;
    if (!state.context) buildContext("teaser_reentry");
    routeTeaserToPilot();
    if (forceMode) {
      window.setTimeout(function () { showGame("force"); }, 50);
      return;
    }
    state.triggerTimer = window.setTimeout(function () {
      window.removeEventListener("scroll", onScroll);
      showGame("delay_6s");
    }, config.triggerDelayMs);
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  installPostscriptLifecycleTracking();
  if (!suppressForForcedMystery && (forceMode || config.autoArm !== false)) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm, { once: true });
    else arm();
  } else {
    routeTeaserToPilot();
  }

  window.TeamK9FetchWelcomeGame = {
    version: VERSION,
    show: function () { showGame("api"); },
    close: function () { closeGame("api"); },
    state: state
  };
})();
